module.exports = __webpack_public_path__ + "img/eggsalad_eggs.59531bb3.jpg";